import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useViewSingleCaseStudy } from "../../hooks/caseStudy/view.single.caseStudy";
import FallbackImage from "../../components/common/fallbackImage";

const CaseStudyDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useViewSingleCaseStudy(id);

  const caseStudy =
    data?.data?.caseStudy ||
    data?.caseStudy ||
    data?.data ||
    data;

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="caseStudyDetails">

      {/* HEADER */}
      <div className="detailsHeader">
        <div>
          <h1>{caseStudy?.title}</h1>
          <p>{caseStudy?.description}</p>
        </div>

        <div className="headerActions">
          <button
            className="editBtn"
            onClick={() => navigate(`/case-studies/edit/${caseStudy?._id || caseStudy?.id}`)}
          >
            Edit
          </button>

          <button
            className="backBtn"
            onClick={() => navigate("/case-studies")}
          >
            Back
          </button>
        </div>
      </div>

      {/* INFO CARDS */}
      <div className="infoGrid">

        <div className="infoCard">
          <span>Client</span>
          <h3>{caseStudy?.client?.name}</h3>
        </div>

        <div className="infoCard">
          <span>Industry</span>
          <h3>{caseStudy?.industry?.title}</h3>
        </div>

        <div className="infoCard">
          <span>Category</span>
          <h3>{caseStudy?.category?.title}</h3>
        </div>

      </div>

      {/* DESCRIPTION */}
      <div className="descriptionCard">
        <h2>Case Study Overview</h2>

        <p>
          {caseStudy?.description}
        </p>
      </div>

      {/* IMAGE GALLERY */}
      <div className="gallerySection">
        <div className="sectionHeader">
          <h2>Project Gallery</h2>
        </div>

        <div className="galleryGrid">
          {caseStudy?.images?.map((img, index) => (
            <div className="galleryCard" key={index}>
              <FallbackImage
                src={img}
                alt={`gallery-${index}`}
              />
            </div>
          ))}
        </div>
      </div>

      

    </div>
  );
};

export default CaseStudyDetails;